import { render, staticRenderFns } from "./TemplateEdit.vue?vue&type=template&id=b12ad564"
import script from "./TemplateEdit.vue?vue&type=script&lang=js"
export * from "./TemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./TemplateEdit.vue?vue&type=style&index=0&id=b12ad564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports